export default __webpack_public_path__ + "static/FancyMediaContentThree-68cb8f185b2233521a23957b91ec2dbe.webp";